/**
 * Departments (teams) resource — admin CRUD + agent assignment (ARCHITECTURE §4).
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { Department, DepartmentInput } from '../../types';

export class DepartmentsResource {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<Department[]> {
    return this.http.get(endpoints.departments.list());
  }

  create(body: DepartmentInput): Promise<Department> {
    return this.http.post(endpoints.departments.create(), body);
  }

  update(id: string, patch: Partial<DepartmentInput>): Promise<Department> {
    return this.http.patch(endpoints.departments.detail(id), patch);
  }

  remove(id: string): Promise<void> {
    return this.http.delete(endpoints.departments.detail(id));
  }
}
